/*
 * Copyright © 2020-2025 XCamera. All Rights Reserved.
 * @Description:
 * @LastEditors: yingongjing
 * @LastEditTime: 2025-10-21 10:27:53
 */
import React from 'react'
import { Tooltip } from 'antd'
import './ColumnHeaderWithTag.css'
import iconEdit from '../assets/icon_edit.png'

interface XCColumnHeaderWithTagProps {
  title: string
  content: string
  width?: number
  height?: number
  isEdit?: boolean
  isAI?: boolean
}

/**
 * 带有AI识别标签的列标题组件
 * @param title - 列标题文本
 * @param content - 提示内容
 * @param width - 容器宽度，与列宽保持一致
 */
const ColumnHeaderWithTag: React.FC<XCColumnHeaderWithTagProps> = ({
  title,
  content,
  width,
  height = 40,
  isEdit = true,
  isAI = true
}) => {
  return (
    <div
      className="tooltip-icon-container"
      style={
        width
          ? {
              width: `${width}px`,
              height: `${height}px`,
              marginLeft: -15,
              justifyContent: 'space-between'
            }
          : undefined
      }
    >
      <div></div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <span className="column-title">{title}</span>
        {isAI && (
          <Tooltip title={content} placement="top">
            <div className="ai-recognition-tag">AI识别</div>
          </Tooltip>
        )}
      </div>
      <div>
        {isEdit && (
          <Tooltip title={'该列内容支持编辑'} placement="top">
            <img
              src={iconEdit}
              alt="该列内容支持编辑"
              style={{ width: 16, height: 16, position: 'relative', right: 10 }}
            />
          </Tooltip>
        )}
      </div>
    </div>
  )
}

export default ColumnHeaderWithTag
